var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg009Bookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.46 21.89C19.7924 21.7178 20.0008 21.3744 20 21V3C20 2.44772 19.5523 2 19 2H5C4.44772 2 4 2.44772 4 3V21C4.00172 21.3735 4.21143 21.7149 4.54379 21.8853C4.87614 22.0557 5.27575 22.0266 5.58 21.81L12 17.23L18.42 21.81C18.5888 21.9322 18.7916 21.9987 19 22C19.1596 21.9981 19.3168 21.9605 19.46 21.89ZM18 19.06L12.58 15.19C12.2328 14.9428 11.7672 14.9428 11.42 15.19L6 19.06V4H18V19.06Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg009Bookmark);
export default __webpack_public_path__ + "static/media/009-bookmark.38dc90350a68962122e2117aea9d563b.svg";
export { ForwardRef as ReactComponent };